import { ColDef } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { azureCoveredUsageColumnDef } from "./common/azureCoveredUsageColumnDef";
import { azureUncoveredUsageColumnDef } from "./common/azureUncoveredUsageColumnDef";
import { azureNetSavingsColumnDef } from "./common/azureNetSavingsColumnDef";
import { getAzureCoverageColumnDef } from "./common/getAzureCoverageColumnDef";
import { AzureSavingsPlanCoverageDataWithId } from "../../../../../../../../common/utils/types";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { agGridEmptyColumnToFitEmptySpace } from "@/components/pages/common/ag-grid/utils/constants/agGridEmptyColumnToFitEmptySpace";

export const azureCoverageGroupedByResourceTypeByRegionFilterTypeColumnDefs: ColDef<AzureSavingsPlanCoverageDataWithId>[] =
  [
    {
      field: "resource_type.resource_type",
      headerName: "Resource Type",
      suppressKeyboardEvent: () => true,
      lockVisible: true,
      suppressColumnsToolPanel: true,
      width: 230,

      cellRenderer: ({
        data,
      }: CustomCellRendererProps<AzureSavingsPlanCoverageDataWithId>) => (
        <TypographyWithTooltip
          title={data?.resource_type?.resource_type ?? ""}
          variant="body2"
          align="left"
          color="primary"
        />
      ),
    },
    {
      field: "resource_type.product_name",
      headerName: "Product Name",
      width: 240,
      flex: 240,
      cellRenderer: ({
        data,
      }: CustomCellRendererProps<AzureSavingsPlanCoverageDataWithId>) => {
        return data?.resource_type?.product_name ?? "-";
      },
    },
    azureCoveredUsageColumnDef,
    azureUncoveredUsageColumnDef,
    azureNetSavingsColumnDef,
    getAzureCoverageColumnDef("resource_type"),
    agGridEmptyColumnToFitEmptySpace,

    // azureTotalCoverageColumnDef // todo: Add this column after the backend fix
  ];
